import React, {createContext, FunctionComponent, useContext, useEffect, useState} from 'react';

import Country from '../networking/models/Country';
import CountryRepository from '../networking/repos/CountryRepository';

interface ICountryContext {
    countries: Country[];
}

const CountryContext = createContext<ICountryContext>({} as ICountryContext);
export const useCountries = () => useContext(CountryContext);

interface Props {
    children: any;
}

const CountryContextProvider: FunctionComponent<Props> = ({ children }) => {
    const [countries, setCountries] = useState<Country[]>([]);

    const [repo] = [
        new CountryRepository(0)
    ];

    useEffect(() => {
        repo.getAll().then(setCountries);
    }, []);

    if(!countries.length)
        return null;

    return (
        <CountryContext.Provider value={{ countries }}>
            { children }
        </CountryContext.Provider>
    );
};

export default CountryContextProvider;

